import React, { useEffect, useState, useCallback } from 'react';
import './App.css';

const API_URL = 'https://api.steamnumberonegame.com/api/coffeemonk_1337/get_games_by_concurrent';
const PAGE_SIZE = 10;

function App() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetch(API_URL)
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        // Convert dictionary to array with appId
        const gamesArray = Object.entries(data).map(([appId, game]) => ({
          ...game,
          appId,
        }));
        setGames(gamesArray);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Lazy load more items on scroll
  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 &&
      visibleCount < games.length
    ) {
      setVisibleCount((prev) => Math.min(prev + PAGE_SIZE, games.length));
    }
  }, [visibleCount, games.length]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const sortedGames = [...games].sort((a, b) => b.concurrent_in_game - a.concurrent_in_game);
  const visibleGames = sortedGames.slice(0, visibleCount);

  return (
    <div className="App">
      <h1 className="title">Steam Number One Game</h1>
      <div className="subtitle">
        Brought to you by{' '}
        <a href="https://discord.gg/3SHpfdQvU6" target="_blank" rel="noopener noreferrer" className="subtitle-link">CoffeemonkCodes</a>
      </div>
      {loading && <div className="loading">Loading games...</div>}
      {error && <div className="error">Error: {error}</div>}
      <div className="game-list">
        {visibleGames.map((game, idx) => (
          <a
            className={`game-row${idx === 0 ? ' number-one' : ''}`}
            key={game.appId}
            href={`https://store.steampowered.com/app/${game.appId}/`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="game-image"
              src={game.imageUrl}
              alt={game.name}
              style={idx === 0 ? { width: 300, height: 140 } : { width: 230, height: 107 }}
            />
            <div className="game-info">
              <div className="game-name">{game.name}</div>
              <div className="game-players">{game.concurrent_in_game.toLocaleString()} active players</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default App;
